import { render, staticRenderFns } from "./copiaCostiAziendali.vue?vue&type=template&id=8f06f754&"
import script from "./copiaCostiAziendali.vue?vue&type=script&lang=js&"
export * from "./copiaCostiAziendali.vue?vue&type=script&lang=js&"
import style0 from "./copiaCostiAziendali.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
